import { createSlice } from "@reduxjs/toolkit";

const supplierGoalsSlice = createSlice({
  name: "goals",
  initialState: {
    goalsQuestions: [],
    goalsAnswer: [],
    goalsformData: {},
    activeTabKey: "Energy",
    goalsFormData: {},
    isSaved: false,
    goalsPillarsStatus:{}
  },
  reducers: {
    setIsSaved(state, action) {
      state.isSaved = action.payload;
    },
    setGoalsQuestions(state, actions) {
      state.goalsQuestions = actions.payload;
    },
    setGoalsAnswer(state, actions) {
      state.goalsAnswer = actions.payload;
    },
    setActiveTabKey(state, actions) {
      state.activeTabKey = actions.payload;
    },
    setGoalsFormData(state, actions) {
      const {
        pillarName,
        questionId,
        inputId,
        value,
        answerId,
        supplierId,
        goalType = "Standard",
        goalCreationYear = new Date().getFullYear(),
      } = actions.payload;
      const currentUser = "ayush";

      let pillar = state.goalsAnswer.find(
        (item) => item.pillarName === pillarName
      );

      if (!pillar) {
        pillar = {
          supplierId: supplierId,
          pillarName: pillarName,
          goalAnswers: [],
          goalType: goalType,
          goalCreationYear,
          updatedUser: currentUser,
          createdUser: currentUser,
        };
        state.goalsAnswer.push(pillar);
      }

      let question = pillar.goalAnswers.find(
        (answer) =>
          answer.questionId === questionId && answer.answerId === answerId
      );

      if (!question) {
        question = {
          questionId: questionId,
          answerId: answerId || "ans_id_1",
          response: [],
          goalStatus: "Active",
        };
        pillar.goalAnswers.push(question);
      }

      let field = question.response.find((f) => f.fieldId === inputId);

      if (!field) {
        field = {
          fieldId: inputId,
          value: value,
        };
        question.response.push(field);
      } else {
        field.value = value;
      }
    },
    setAddDynamicQuestion(state, actions) {
      const { pillarName } = actions.payload;
      state.goalsAnswer.filter((p) => p.pillarName === pillarName);
    },
    setGoalsPillarsStatus(state, actions){
      state.goalsPillarsStatus = actions.payload
    }
  },
});

export const {
  setGoalsQuestions,
  setGoalsAnswer,
  setActiveTabKey,
  setGoalsFormData,
  setAddDynamicQuestion,
  setIsSaved,
  setGoalsPillarsStatus
} = supplierGoalsSlice.actions;
export default supplierGoalsSlice.reducer;
